import React, { useState } from 'react';
import Collapsible from 'react-collapsible';
import css from './FemxProfileFieldSViewPage.module.css';
import { FormattedMessage } from 'react-intl';
import { IoIosArrowDown } from 'react-icons/io';
import { IoIosArrowUp } from 'react-icons/io';
import CustomListingFields from './CustomListingFields';
import SectionReviews from './SectionReviews';
import { NamedLink } from '../../components';
import { isCompleteProfile } from '../../util/uiHelpers';

export default function FemxProfileFieldSViewPage(props) {
  const {
    metadata,
    publicData,
    listingFieldConfigs,
    categoryConfiguration,
    intl,
    reviews,
    fetchReviewsError,
    currentUser,
    isOwnListing,
    author,
  } = props;
  const {
    emailVerified,
    listingState,
    listingId,
    listingTitle,
    membership: isMemberShip,
  } = isCompleteProfile(currentUser);
  const isCompletedFemxProfile = listingState == 'edit';

  
  const draftId = '00000000-0000-0000-0000-000000000000';
  const draftSlug = 'draft';
  const [Tabs, SetTabs] = useState([
    { tab: 'OVERVIEW', isOpen: false },
    { tab: 'ABOUT', isOpen: false },
    { tab: 'REVIEWS', isOpen: false },
  ]);

  const handleToggle = tabName => {
    SetTabs(prevTabs =>
      prevTabs.map(tab =>
        tab.tab === tabName ? { ...tab, isOpen: !tab.isOpen } : { ...tab, isOpen: tab.isOpen }
      )
    );
  };

  return (
    <div className={css.ParenOfCollapsibes}>
      {Tabs.map(val => {
        return (
          <Collapsible
            trigger={
              <div className={css.triggerParent} onClick={() => handleToggle(val.tab)}>
                <div>{val.tab} {val.tab == 'REVIEWS' ?`(${reviews?.length})`:null}</div>
                <div>
                  {val?.isOpen ? <IoIosArrowUp className={css.arrowUpDown} /> : <IoIosArrowDown />}
                </div>
              </div>
            }
            // onOpening ={handleToggle(val.tab)}
            // onClosing={handleToggle(val.tab)}
            triggerClassName={css.collapsibleTrigger} // Collapsed state
            triggerOpenedClassName={css.collapsibleTriggerOpened} // Opened state
            classParentString={css.collapsibleParent} // Parent container
            contentInnerClassName={css.content}
          >
            <div className={css.contentt}>
              {val.tab == 'REVIEWS' ? (
                !isOwnListing && (!currentUser || !isMemberShip || !isCompletedFemxProfile) ? (
                  <div className={css.gatedReviews}>
                    <NamedLink
                      name={
                        !currentUser
                          ? 'SignupPage'
                          : !isCompletedFemxProfile
                          ? 'EditListingPage'
                          : !isMemberShip
                          ? 'MembershipPage'
                          : 'SignupPage'
                      }
                      params={
                        currentUser && !isCompletedFemxProfile
                          ? listingId && listingTitle
                            ? {
                                slug: listingTitle,
                                id: listingId,
                                type: listingState,
                                tab: 'details',
                                isFemx: 'femxProfile',
                              }
                            : {
                                slug: draftSlug,
                                id: draftId,
                                type: 'new',
                                tab: 'details',
                                isFemx: 'femxProfile',
                              }
                          : null
                      }
                      className={css.signupLink}
                    >
                      {!currentUser ? (
                        <FormattedMessage id="SignUp.Link" />
                      ) : (
                        <FormattedMessage id="CompleteProfile.Link" />
                      )}
                    </NamedLink>
                  </div>
                ) : (
                  <SectionReviews reviews={reviews} fetchReviewsError={fetchReviewsError} />
                )
              ) : (
                <CustomListingFields
                  publicData={publicData}
                  metadata={metadata}
                  listingFieldConfigs={listingFieldConfigs}
                  categoryConfiguration={categoryConfiguration}
                  intl={intl}
                  FemxProfileListing={true}
                  tab={val.tab}
                  currentUser={currentUser}
                  x
                  isOwnListing={isOwnListing}
                />
              )}
            </div>
          </Collapsible>
        );
      })}
    </div>
  );
}
